import { render, staticRenderFns } from "./medicalHistoryDialog.vue?vue&type=template&id=8450d726&"
import script from "./medicalHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./medicalHistoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports